import { SvgIcon, SvgIconProps } from '@mui/material';

const PeopleOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="PeopleOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.49805 12.5C8.57816 12.5 10.1349 12.626 11.4561 13.2627C12.1299 13.5876 12.7754 14.0612 13.251 14.748C13.7323 15.4433 13.998 16.2977 13.998 17.3076V18C13.998 19.1046 13.1026 20 11.998 20H2.99805C1.89359 19.9999 0.998047 19.1045 0.998047 18V17.3076C0.99806 16.2977 1.26385 15.4432 1.74512 14.748C2.22067 14.0612 2.86618 13.5876 3.54004 13.2627C4.86117 12.6259 6.41789 12.5 7.49805 12.5ZM7.49805 14.5C6.51585 14.5 5.32222 14.6245 4.40918 15.0645C3.96614 15.278 3.62292 15.5498 3.38965 15.8867C3.16209 16.2155 2.99806 16.6639 2.99805 17.3076V18H11.998V17.3076C11.998 16.6639 11.834 16.2155 11.6064 15.8867C11.3731 15.5498 11.03 15.278 10.5869 15.0645C9.67383 14.6245 8.48022 14.5 7.49805 14.5Z"
      />
      <path d="M16.5 12.5C17.5802 12.5 19.1368 12.6259 20.458 13.2627C21.1319 13.5876 21.7773 14.0611 22.2529 14.748C22.7343 15.4433 23 16.2977 23 17.3076V18.333C23 19.2535 22.2535 20 21.333 20H15.0898C15.0898 20 15.348 19.8228 15.5312 19.2305C15.75 18.5234 15.75 17.9961 15.75 17.9961L21 18V17.3076C21 16.6638 20.836 16.2155 20.6084 15.8867C20.3751 15.5497 20.032 15.278 19.5889 15.0645C18.6758 14.6245 17.4822 14.5 16.5 14.5C16.11 14.5 15.6139 14.5198 15.1719 14.5742C15.1719 14.5742 15 14.2125 14.8164 13.8945C14.6328 13.5765 14.0156 12.7266 14.0156 12.7266C14.8179 12.5317 15.8613 12.5 16.5 12.5Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33398 4C9.35877 4.00031 11 5.64214 11 7.66699C10.9998 9.6917 9.35866 11.3327 7.33398 11.333C5.30905 11.333 3.66717 9.69189 3.66699 7.66699C3.66699 5.64195 5.30894 4 7.33398 4ZM7.33398 6C6.41351 6 5.66699 6.74652 5.66699 7.66699C5.66717 8.58732 6.41362 9.33301 7.33398 9.33301C8.25409 9.3327 8.99982 8.58713 9 7.66699C9 6.74671 8.2542 6.00031 7.33398 6Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6641 4C18.6888 4.00031 20.3301 5.64214 20.3301 7.66699C20.3299 9.6917 18.6887 11.3327 16.6641 11.333C14.6391 11.333 12.9972 9.69189 12.9971 7.66699C12.9971 5.64195 14.639 4 16.6641 4ZM16.6641 6C15.7436 6 14.9971 6.74652 14.9971 7.66699C14.9972 8.58732 15.7437 9.33301 16.6641 9.33301C17.5842 9.3327 18.3299 8.58713 18.3301 7.66699C18.3301 6.74671 17.5843 6.00031 16.6641 6Z"
      />
    </SvgIcon>
  );
};

export default PeopleOutlined;
